<template>
  <section>
    <b-field>
      <b-autocomplete
        rounded
        v-model="name"
        :data="filteredDataArray"
        placeholder="Search all locations"
        icon="search"
        @select="option => (selected = option)"
        field="name"
        open-on-focus
        aria-label="Search all locations"
      >
        <template slot="empty"
          >No results found</template
        >
      </b-autocomplete>
    </b-field>
  </section>
</template>

<script>
var VueScrollTo = require("vue-scrollto");
import Fuse from "fuse.js";

export default {
  data() {
    return {
      name: "",
      selected: null
    };
  },
  computed: {
    filteredDataArray() {
      const allFloors = this.$store.state.buildings
        .map(building => building.floors)
        .flat();
      const allLocations = allFloors.map(floor => floor.locations).flat();

      var options = {
        shouldSort: true,
        findAllMatches: true,
        threshold: 0.6,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ["name"]
      };

      var fuse = new Fuse(allLocations, options);
      var result = fuse.search(this.name);
      return result;
    }
  },
  watch: {
    selected: function(newSelected) {
      console.log("New selected in search!");
      console.log(newSelected);
      if (newSelected === null) return;
      // Bad performance on lots of locations!
      for (var b of this.$store.state.buildings) {
        for (var f of b.floors) {
          for (var l of f.locations) {
            if (l == newSelected) {
              console.log("this is the one");
              this.$store.commit("SET_SELECTED_BUILDING_ID", b.id);
              this.$store.commit("SET_SELECTED_FLOOR_ID", f.id);
              this.$store.commit("SET_SELECTED_LOCATION_ID", l.id);
              this.$router.push("locations");

              var options = {
                container: "#table",
                easing: "ease-in",
                offset: -60,
                force: true,
                cancelable: true,
                onStart: function(element) {},
                onDone: function(element) {},
                onCancel: function() {},
                x: false,
                y: true
              };
              const elementName = l.name;
              console.log("elementName: " + elementName);
              setTimeout(function() {
                console.log("Scrolling");
                var cancelScroll = VueScrollTo.scrollTo(
                  "#" + elementName.replace("@", "ATSIGN"),
                  10,
                  options
                );
              }, 300);
            }
          }
        }
      }
    }
  }
};
</script>
<style scoped></style>
